module.exports = __webpack_public_path__ + "img/florasis.DBoXQo-H.34c3cc11.png";